module.exports = __webpack_public_path__ + "static/media/message-new.65c9df00.svg";